import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {VM} from '@hetao/scratch-core';
import {connect} from 'react-redux';
import {getConfig} from '../lib/service';
import {getHomeworkInfo} from '../lib/homework-info';
import {saveProjectData} from '../lib/project-savedata.js';

// import analytics from '../lib/analytics';
import ControlsComponent from '../components/controls/controls.jsx';
import scratchTester from '../lib/scratch-tester/index';

class Controls extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            upLoadLine: 'qiniu',
            count: 0
        };
        getConfig().then(
            config => {
                this.setState({
                    upLoadLine: config.uploadType
                });
            }
        );
        bindAll(this, [
            'handleGreenFlagClick',
            'handleStopAllClick'
        ]);
    }
    handleGreenFlagClick (e) {
        this.setState(prevState => ({count: prevState.count + 1}));
        e.preventDefault();
        if (e.shiftKey) {
            this.props.vm.setTurboMode(!this.props.turbo);
        } else {
            scratchTester.startTest().then(() => {
                this.props.vm.greenFlag();
                // analytics.event({
                //     category: 'general',
                //     action: 'Green Flag'
                // });
                const count = this.state.count;
                const homeworkInfo = getHomeworkInfo();
                const courseId = Number(homeworkInfo.courseId);
                const unitId = Number(homeworkInfo.unitId);
                const lessonId = Number(homeworkInfo.lessonId);
                const projectUrl = homeworkInfo.projectUrl;
                this.props.vm.saveProjectSb3(true).then(content => {
                    saveProjectData(content, count, this.state.upLoadLine)
                        .then(res => {
                            ht.track('s3_stage_play', {
                                context: {
                                    courseId: courseId,
                                    unitId: unitId,
                                    lessonId: lessonId,
                                    currentUrl: location.href,
                                    stageDisplayMode: localStorage.getItem('stageDisplayMode')
                                },
                                param: {
                                    homeworkFileUrl: `https:${projectUrl}`,
                                    blockListUrl: `https:${res}`
                                }
                            });
                    });
                });
            })
        }
    }
    handleStopAllClick (e) {
        e.preventDefault();
        this.props.vm.stopAll();
        // analytics.event({
        //     category: 'general',
        //     action: 'Stop Button'
        // });
    }
    render () {
        const {
            vm, // eslint-disable-line no-unused-vars
            projectRunning,
            turbo,
            ...props
        } = this.props;
        return (
            <ControlsComponent
                {...props}
                active={projectRunning}
                turbo={turbo}
                onGreenFlagClick={this.handleGreenFlagClick}
                onStopAllClick={this.handleStopAllClick}
            />
        );
    }
}

Controls.propTypes = {
    projectRunning: PropTypes.bool.isRequired,
    turbo: PropTypes.bool.isRequired,
    vm: PropTypes.instanceOf(VM)
};

const mapStateToProps = state => ({
    projectRunning: state.scratchGui.vmStatus.running,
    turbo: state.scratchGui.vmStatus.turbo
});

export default connect(mapStateToProps)(Controls);
